import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState, store } from '../redux/store';
import { getLocalData } from '../utils/storage';
import { login } from '../screens/auth/login/reducer';
import { BrowserRouter } from 'react-router-dom';
import { MainLayoutProvider } from './routeMainLayout/context';
import RouteSwitcher from './routeSwitcher';
import { keys } from '../api/keys';
import AppLoading from './AppLoading';
import { toggleDarkMode } from '../screens/content/settings/action';

const AppNavigator = () => {
  const [isInitialized, setIsInitialized] = useState(false);
  const userStatus = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    initApp();
  }, []);

  const initApp = async () => {
    const currentUser = await getLocalData(keys.CURRENT_USER);
    if (currentUser && Object.keys(currentUser || {}).length !== 0) {
      store.dispatch(login(currentUser));
    } else {
      store.dispatch(login(null));
    }
    await getLocalData(keys.DARK_MODE);
    toggleDarkMode({ isInitialize: true });
    setIsInitialized(true);
  };

  if (!isInitialized) {
    return <AppLoading />;
  }

  return (
    <MainLayoutProvider>
      <BrowserRouter>
        <RouteSwitcher isAuthenticated={!!userStatus?.currentUser?.access_token} />
      </BrowserRouter>
    </MainLayoutProvider>
  );
};

export default AppNavigator;
